import { t } from "../../i18n";
import { ListTodo } from "lucide-react";
import { todoListFromToolEvent, type ToolEvent } from "@lumen/shared";
import { ToolEventTimestamp } from "./ToolEventTimestamp";

export function TodoUpdateActivity({ event }: { event: ToolEvent }) {
  const snapshot = todoListFromToolEvent(event);
  if (!snapshot)
    return (
      <div className="flex items-center gap-2 rounded-lg border border-red-200 bg-red-50/70 px-3 py-2 text-xs text-red-700 dark:border-red-900/60 dark:bg-red-950/20 dark:text-red-300">
        <ListTodo size={14} />
        <span>{t("Todo update failed")}</span>
        {event.startedAt && (
          <span
            className="ml-auto shrink-0 text-[10px] text-red-400 tabular-nums"
            title={new Date(event.startedAt).toLocaleString()}
          >
            {new Date(event.startedAt).toLocaleTimeString()}
          </span>
        )}
      </div>
    );
  const active = snapshot.todos.find((todo) => todo.status === "in_progress");
  return (
    <div className="flex items-center gap-2 rounded-lg border border-violet-200 bg-violet-50/60 px-3 py-2 text-xs dark:border-violet-900/60 dark:bg-violet-950/20">
      <ListTodo
        size={14}
        className="shrink-0 text-violet-600 dark:text-violet-300"
      />
      <span className="font-semibold text-stone-600 dark:text-stone-300">
        {t("Updated tasks")}
      </span>
      <span className="min-w-0 flex-1 truncate text-stone-400">
        {snapshot.explanation ||
          active?.content ||
          (snapshot.completed === snapshot.total
            ? "All tasks completed"
            : "Progress updated")}
      </span>
      <span className="shrink-0 font-semibold text-violet-700 dark:text-violet-300">
        {snapshot.completed}/{snapshot.total}
      </span>
      <ToolEventTimestamp
        event={event}
        className="shrink-0 text-[10px] text-stone-400 tabular-nums"
      />
    </div>
  );
}
